import Vue from "vue";
import themes_en from '@/assets/data/themes_en.json'
import themes_fr from '@/assets/data/themes_fr.json'

const ThemeService = {
    base_api() {
        let base = process.env.VUE_APP_CWM_API_URL || "https://www.warmuseum.ca/_api";
        return base;

    },
    /**
     * Retrieve all of Medals
     * @param {*} lang The language, either `en` or `fr`
     */

     all(lang) {
        switch(lang) {
            case 'en':
                return themes_en
            case 'fr':
                return themes_fr
            default:
                return null
        }
    },

    /**
     * Retrieve all recipients by given theme
     * @param {*} lang The language, either `en` or `fr`
     * @param {*} slug
     */
    recipients(lang, slug) {
        var endpoint = `${this.base_api()}/_search/${lang}/medals/person/${slug}`;

        return Vue.axios.get(endpoint, {
            params: {
                sort: 'NamLast',
                size: 500
            }
         })
            .catch(error => {
                throw new Error(`ApiService::list ${error}`);
            });
    }
};

export default ThemeService;
